
  <div class="row">
    <div class="col-lg-12 grid-margin">
      <div class="card">
        <div class="card-body upper-header">
            <div class="row">
                <div class="form-group col-1.5 ml-2">
                  <label>From Date</label>
                  <input class="form-control border-primary" [max] = "to_date" [owlDateTime]="dt" placeholder="Date" name="from_date"
                    [(ngModel)]="from_date" readonly>
                  <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
                  <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                </div>
                <div class="form-group col-1.5 ml-2 mr-2">
                    <label>To Date</label>
                    <input class="form-control border-primary" [min]="from_date" [max] = "maxDate" [owlDateTime]="dt1" placeholder="Date" name="to_date"
                      [(ngModel)]="to_date" readonly>
                    <span [owlDateTimeTrigger]="dt1" class="date-ico"><i class="fa fa-calendar"></i></span>
                    <owl-date-time #dt1 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
                </div>
                <div class="form-group col-2">
                    <label>Payment Status</label>
                    <select class="form-control border-primary" name="payment_status" [(ngModel)]="payment_status">
                      <option [value]="''">All</option>
                      <option value="pending">Pending</option>
                      <option value="paid">Paid</option>
                    </select>
                </div>
                <div class="form-group col-2">
                    <label>Meal Type</label>
                    <select class="form-control border-primary" name="annakshetra_meal_type_id" [(ngModel)]="annakshetra_meal_type_id">
                      <option [value]="''">All</option>
                      <option *ngFor="let meal of allMealTypes" [value]="meal.id">{{meal.title}}</option>
                    </select>
                </div>
                <div class="form-group col-2">
                  <button type="button" style="margin-top: 30px;" class="btn btn-primary btn-fw" (click)="getList($event)">Load</button>
                </div>
                <div class="ml-auto p-2 bd-highlight">
                  <div class="form-group" style="text-align:right;align-items: right;">
                    <a title="Add Annadaan"  (click) = "navigateTo('add-annadaan')"> <i class="fa fa-plus-circle" style="font-size: 35px;cursor: pointer;margin-top: 30px;" aria-hidden="true"></i></a>
                  </div>
                </div>
              </div>
          <h4 class="card-title">
            <div class="d-flex bd-highlight">
              <div class="p-2 flex-grow-1 bd-highlight">Annadaan</div>
              <div class="p-2 bd-highlight">
                <button type="btn" class="btn btn-primary btn-fw" (click)="exportData()">Export</button>
              </div>
            </div>
          </h4>
          <div class="table-responsive" *ngIf="allAnnadaanBooking && allAnnadaanBooking.data && allAnnadaanBooking.data.length">
            <table class="table">
              <thead>
              <tr>
                <th>S.No</th>
                <!-- <th>Receipt No.</th> -->
                <th>Name</th>
                <th>Occasion</th>
                <th>Mobile No.</th>
                <!-- <th>Pan Card</th> -->
                <th>Annadaan Date</th>
                <th>Bhojan Prasad</th>
                <th>Payment Status</th>

                <th>Amount</th>
                <th>Bhog Donation</th>
                <th>Payment Type</th>
                <th>Transaction ID</th>
                <th>Donation Receipt</th>
                <th>Annadaan Samman Patra</th>
                <th>80G Receipt</th>
                 <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let data of allAnnadaanBooking?.data; let i = index">
                <td>
                  <span *ngIf = "page == 1">{{i+1}}</span>
                  <span *ngIf = "page > 1">{{((page - 1 )*perPage) + (i+1)}}</span>
                </td>
                
                <!-- <td>{{data?.receipt_no}}</td> -->
                <td>{{data?.full_name}}</td>
                <td>{{data?.occasion}}</td>
                <td>{{data?.mobile_no}}</td>
                <!-- <td>{{data?.pan_card_no}}</td> -->
                <td>{{data?.donation_date}}</td>
                <td>{{data?.meal_type?.title}}</td>
                <td>{{data?.payment_process_completed ? 'Paid' : 'Pending'}}</td>
                <td>{{data?.amount}}</td>
                <td>{{data?.is_bhog_donor ? 'Yes' : 'No'}}</td>
                <td>{{data?.payment_details && data.payment_details.length > 0 ? (data.payment_details[0].payment_type?.type || 'N/A') : 'N/A'}}</td>
                <td>{{data?.payment_details && data.payment_details.length > 0 ? (data.payment_details[0]?.trx_id || 'N/A') : 'N/A'}}</td>
                <td>
                  <a *ngIf="data.payment_process_completed == true" title="Donation Receipt" class="ml-4" [href]="data.certificates?.donation_receipt?.url" target="_blank">
                    <i class="fa fa-download" style="font-size: 24px !important;" aria-hidden="true"></i>
                  </a>
                </td>
                <td>
                  <a *ngIf="data.payment_process_completed == true" title="Annadaan Samman Patra" class="ml-4" [href]="data.certificates?.thank_you_slip?.url" target="_blank">
                    <i class="fa fa-download" style="font-size: 24px !important;" aria-hidden="true"></i>
                  </a>
                </td>
                <td>
                  <a *ngIf="data.payment_process_completed == true && data.certificates && data.certificates['80g_certificate']"
                    title="80G Certificate"
                    class="ml-4"
                    [href]="data.certificates && data.certificates['80g_certificate'] ? data.certificates['80g_certificate'].url : null"
                    target="_blank">

                    <i
                        class="fa fa-download"
                        style="font-size: 24px !important;"
                        aria-hidden="true">
                    </i>

                    </a>
                </td>
                <td>
                  <a title="Pay" class="ml-4" *ngIf="data.payment_process_completed == false"><i class="fa fa-credit-card" aria-hidden="true"
                   routerLink="/annadaan-payment/{{data.id}}"></i></a>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="p-12" *ngIf="allAnnadaanBooking && allAnnadaanBooking.data && !allAnnadaanBooking.data.length">
            <span class="ng-star-inserted no_data" >No Data found.</span>
          </div>
          <ngb-pagination  *ngIf="allAnnadaanBooking && allAnnadaanBooking.data && allAnnadaanBooking.data.length" [collectionSize]="totalCount" [pageSize]="perPage"
          [(page)]="page" [maxSize]="3" (pageChange)="getList('pagination')"
          class="pull-right justify-content-end page-mt-10"
          aria-label="Default pagination"></ngb-pagination>
        </div>
      </div>
    </div>
  </div>

